import { render } from "./DetalharFormaPagamento.vue?vue&type=template&id=1a90ec77&scoped=true"
import script from "./DetalharFormaPagamento.vue?vue&type=script&lang=js"
export * from "./DetalharFormaPagamento.vue?vue&type=script&lang=js"

import "./DetalharFormaPagamento.vue?vue&type=style&index=0&id=1a90ec77&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a90ec77"]])

export default __exports__